export const fuseNavigationConfig = [
    {
        'id'      : 'tools',
        'title'   : 'Tools',
        'type'    : 'group',
        'icon'    : 'apps',
        'children': [
            {
                'id'   : 'components-component',
                'title': 'Components',
                'type' : 'item',
                'icon' : 'whatshot',
                'url'  : '/components'
            }
        ]
    }
];
